module.exports = __webpack_public_path__ + "img/how-it-works4.c4a6bd85.svg";